export default class AvailableTranslationReferenceCacheName {
  static getAvailableTranslationReference(): string {
    return "availableTranslationReference";
  }
}
